import React from "react";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import RadioButton from "../components/RadioButton";
import SelectWrapper from "../components/Select";
import TextInput from "../components/TextInput";
import UploadButton from "../components/UploadButton";
import DatePick from "../components/DatePick";
import TimePick from "../components/TimePick";
import { CheckBox, Search, Visibility, VisibilityOff } from "@mui/icons-material";
import { Controller } from "react-hook-form";
import YearMonthPicker from "../components/YearMonthPick/YearMonthPicker";
import SelectWrappers from "../components/multipleSelect";
import SearchSelect from "../components/SearchSelect";

const InputWrapper = ({
  label,
  width,
  height,
  disabled = false,
  selectSuffix = null,
  hasLabel = true,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine = false,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData,
  containerStyles,
  containerClasses,
  getIndex,
  getArea,
  validation,
  maxLength,
  showSearchIcon,
  onSearchClick,
  isRequired,
  maxDate,
  disableFuture,
  disablePast,
  minLength,
  maxValue,
  allowedChars,
  onBlur,
  inputClassName,
  message,
  customLabel,
  onlyNumeric = false, // New prop to control numeric input with special characters
  customLabelStyles,
  trimSpace = false, // New prop to control space trimming
  returnObject = false, // New prop to control return object behavior in SearchSelect
  isPassword = false,
  decimalScale = null, // New prop to control decimal places in special char input
  onlyAlphabet = false,
  formatOnBlur = false,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className={`inputContainer`} style={containerStyles}>
      {hasLabel && type !== "checkbox" && (
        <h3
          className={`label ${multiColumn ? "multiCoumn" : customLabel ? customLabel : ""}`}
          style={{
            width: labelWidth && labelWidth,
            height: height || "30px",
            ...customLabelStyles, // <-- Spread custom styles here
          }}
        >
          {label}
          {mandatory && <span className="compulsoryField"> *</span>}
        </h3>
      )}
      {type === "textInput" ? (
        <React.Fragment>
          {selectSuffix && (
            <SelectWrapper
              //control={selectSuffix.control}
              variant="outlined"
              width="6vw"
              size="small"
              {...selectSuffix}
              defaultValue={selectSuffix?.defaultValue}
              validation={validation}
            />
          )}
          <TextInput
            placeholder={placeholder}
            variant="outlined"
            size="small"
            disabled={disabled}
            width={width || (selectSuffix ? "11.25vw" : "18.25vw")}
            height={height}
            name={name}
            message={message}
            select={select}
            control={control}
            defaultValue={defaultValue}
            multiline={multiLine}
            maxValue={maxValue}
            isRequired={isRequired}
            inputClassName={inputClassName}
            InputProps={{
              ...(mobileNumber && {
                startAdornment: <InputAdornment position="start">+91</InputAdornment>,
              }),
              endAdornment: showSearchIcon && ( // Conditionally render search icon
                <InputAdornment position="end">
                  <IconButton onClick={onSearchClick}>
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
              sx: {
                height: height || "30px", // Apply height to the input field directly
              },
            }}
            validation={validation}
            inputProps={{ maxLength }}
            onInput={(e) => {
              let value = e.target.value;
              // ...existing logic...
              // Add this for trimSpace
              if (onlyAlphabet) {
                // allow only alphabets and spaces
                value = value.replace(/[^A-Za-z\s]/g, "");

                // remove starting spaces
                value = value.replace(/^\s+/g, "");

                // allow only single space between words
                value = value.replace(/\s{2,}/g, " ");
              }
              if (trimSpace) {
                value = value.replace(/\s/g, ""); // Remove all spaces
              }

              // Limit the input to maxLength
              if (maxLength && value.length > maxLength) {
                value = value.slice(0, maxLength);
              }
              e.target.value = value;
            }}
          >
            {!selectSuffix &&
              data &&
              select &&
              data?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
          </TextInput>
        </React.Fragment>
      ) : type === "radioButton" ? (
        <RadioButton
          defaultValue={defaultValue}
          clickControl={clickControl}
          control={control}
          width={width}
          data={data}
          name={name}
          row
          validation={validation}
          disabled={disabled}
          inputClassName={inputClassName}
        />
      ) : type === "selectInput" ? (
        <SelectWrapper
          control={control}
          placeholder={placeholder}
          defaultValue={defaultValue}
          inputLabel={placeholder}
          width={width || "18.25vw"}
          height={height}
          label={label}
          data={data}
          name={name}
          disabled={disabled}
          validation={validation}
          onBlur={onBlur}
          InputProps={
            {
              // style: { borderRadius: "5px" },
            }
          }
        />
      ) : type === "multiSelectInput" ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue || []}
          rules={validation}
          render={({ field: { onChange, value } }) => (
            <Select
              multiple
              displayEmpty
              value={value}
              onChange={(e) => onChange(e.target.value)}
              renderValue={(selected) =>
                selected.length
                  ? selected
                      .map((val) => {
                        const found = data.find((d) => d.value === val);
                        return found?.label || val;
                      })
                      .join(", ")
                  : placeholder
              }
              size="small"
              fullWidth
              sx={{ backgroundColor: "#fff" }}
            >
              {data.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  <Checkbox checked={value.includes(option.value)} />
                  <ListItemText primary={option.label} />
                </MenuItem>
              ))}
            </Select>
          )}
        />
      ) : type === "multiSelectInputs" ? (
        <SelectWrappers
          control={control}
          placeholder={placeholder}
          defaultValue={defaultValue || []}
          inputLabel={placeholder}
          width={width}
          height={height}
          label={label}
          data={data}
          name={name}
          multiple={true}
          disabled={disabled}
          validation={validation}
          onBlur={onBlur}
        />
      ) : type === "upload" ? (
        <UploadButton error={uploadValidity} />
      ) : type === "htmlUpload" ? (
        <div className="uploadHtml">
          <input type="file" name={name} onChange={(e) => getDocumentData(e?.target?.files[0], name)} />
          <h6 className="error">{uploadValidity}</h6>
        </div>
      ) : type === "datePicker" ? (
        <DatePick
          placeholder={placeholder}
          control={control}
          // label={label}
          name={name}
          width={width}
          defaultValue={defaultValue}
          validation={validation}
          maxDate={maxDate}
          disableFuture={disableFuture}
          disablePast={disablePast}
          disabled={disabled}
        />
      ) : type === "yearMonthPicker" ? (
        <YearMonthPicker
          label={label}
          control={control}
          name={name}
          validation={validation}
          placeholder={placeholder}
          defaultValue={defaultValue}
          disabled={disabled}
        />
      ) : type === "timePicker" ? (
        <TimePick control={control} label={label} name={name} defaultValue={defaultValue} />
      ) : type === "number" ? (
        <TextInput
          // label={placeholder || label}
          // label={placeholder || label}
          placeholder={placeholder}
          variant="outlined"
          size="small"
          // type="text"
          disabled={disabled}
          width={width || "18.25vw"}
          height={height}
          name={name}
          control={control}
          isRequired={isRequired}
          defaultValue={defaultValue}
          validation={validation}
          inputClassName={inputClassName}
          InputProps={{
            ...(mobileNumber && {
              startAdornment: <InputAdornment position="start">+91</InputAdornment>,
            }),
            style: { borderRadius: "1px" },
            sx: {
              height: height || "30px", // Apply height to the input field directly
            },
          }}
          onInput={(e) => {
            let value = e.target.value;

            // Allow only digits (0-9)
            value = value.replace(/[^0-9]/g, ""); // Remove anything that's not a number

            // Limit the input to maxLength
            const max = maxLength ? parseInt(maxLength, 10) : null;
            if (max && value.length > max) {
              value = value.slice(0, max); // Restrict input to maxLength
            }

            // Update the value in the input field
            e.target.value = value;
          }}
        />
      ) : type === "checkbox" ? (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { onChange, value } }) => (
            <Checkbox
              checked={value} // Control the checked state
              sx={containerStyles}
              onChange={(e) => {
                onChange(e.target.checked); // Update form state
              }}
              disabled={disabled}
            />
          )}
        />
      ) : type === "decimal" ? (
        <TextInput
          placeholder={placeholder}
          variant="outlined"
          size="small"
          type="text"
          disabled={disabled}
          width={width || "18.25vw"}
          height={height}
          name={name}
          control={control}
          validation={validation}
          isRequired={isRequired}
          defaultValue={defaultValue}
          minLength={minLength}
          maxLength={maxLength}
          maxValue={maxValue}
          message={message}
          inputProps={{
            maxLength,
            inputMode: "decimal",
          }}
          InputProps={{
            style: { borderRadius: "1px" },
            sx: {
              height: height || "30px",
            },
          }}
          onInput={(e) => {
            const input = e.target;
            const cursorPosition = input.selectionStart;

            let value = input.value.replace(/[^0-9.]/g, "");

            // Allow only one decimal point
            const parts = value.split(".");
            if (parts.length > 2) {
              value = `${parts[0]}.${parts.slice(1).join("")}`;
            }

            // Restrict total characters
            const max = maxLength ? Number(maxLength) : null;
            if (max && value.length > max) {
              value = value.slice(0, max);
            }

            if (input.value !== value) {
              input.value = value;

              requestAnimationFrame(() => {
                const newPosition = Math.min(cursorPosition, value.length);
                input.setSelectionRange(newPosition, newPosition);
              });
            }
          }}
        />
      ) : type === "specialChar" ? (
        <TextInput
          placeholder={placeholder}
          variant="outlined"
          size="small"
          disabled={disabled}
          width={width || "18.25vw"}
          height={height}
          name={name}
          control={control}
          isRequired={isRequired}
          defaultValue={defaultValue}
          validation={validation}
          decimalScale={decimalScale}
          formatOnBlur={formatOnBlur}
          InputProps={{
            style: { borderRadius: "1px" },
            sx: {
              height: height || "30px", // Apply height to the input field directly
            },
          }}
          // onInput={(e) => {
          //   let value = e.target.value;

          //   // Escape any special characters in allowedChars
          //   const escapeRegex = (str) => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
          //   const escapedPattern = allowedChars ? escapeRegex(allowedChars) : "";

          //   // If onlyNumeric is true, allow only numbers and allowed special characters
          //   if (onlyNumeric) {
          //     const regex = new RegExp(`[^0-9${escapedPattern}]`, "g");
          //     value = value.replace(regex, "");
          //   } else {
          //     // Default: allow alphanumeric and allowed special characters
          //     const regex = new RegExp(`[^0-9A-Za-z${escapedPattern}]`, "g");
          //     value = value.replace(regex, "");
          //   }

          //   // Limit the input to maxLength
          //   if (maxLength && value.length > maxLength) {
          //     value = value.slice(0, maxLength);
          //   }

          //   e.target.value = value;
          // }}

          // In this new function added functionality to restrict user to enter decimal to certain limit
          onInput={(e) => {
            let value = e.target.value;

            // Escape special chars safely
            const escapeRegex = (str) => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");

            const escapedPattern = allowedChars ? escapeRegex(allowedChars) : "";

            // Allow only numeric + allowed special chars
            if (onlyNumeric) {
              const regex = new RegExp(`[^0-9${escapedPattern}]`, "g");

              value = value.replace(regex, "");
            } else {
              // Default alphanumeric + allowed chars
              const regex = new RegExp(`[^0-9A-Za-z${escapedPattern}]`, "g");

              value = value.replace(regex, "");
            }

            // Prevent multiple decimals
            if (allowedChars?.includes(".")) {
              const parts = value.split(".");

              if (parts.length > 2) {
                value = parts[0] + "." + parts.slice(1).join("");
              }

              // Restrict decimal digits ONLY if decimalScale provided
              if (decimalScale !== null && parts[1]) {
                value = parts[0] + "." + parts[1].slice(0, decimalScale);
              }
            }

            // Max length restriction
            if (maxLength && value.length > maxLength) {
              value = value.slice(0, maxLength);
            }

            e.target.value = value;
          }}
        />
      ) : type === "searchSelect" ? (
        <SearchSelect
          name={name}
          control={control}
          data={data}
          placeholder={placeholder}
          disabled={disabled}
          validation={validation}
          defaultValue={defaultValue}
          width={width}
          height={height}
          select={select}
          returnObject={returnObject}
        />
      ) : type === "password" ? (
        <TextInput
          placeholder={placeholder}
          variant="outlined"
          size="small"
          disabled={disabled}
          width={width || "18.25vw"}
          height={height}
          name={name}
          control={control}
          defaultValue={defaultValue}
          validation={validation}
          isRequired={isRequired}
          inputClassName={inputClassName}
          type={showPassword ? "textInput" : "password"} // 🔥 THIS IS THE FIX
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            sx: {
              height: height || "30px",
            },
          }}
          inputProps={{ maxLength }}
          onInput={(e) => {
            let value = e.target.value;

            if (trimSpace) {
              value = value.replace(/\s/g, "");
            }

            if (maxLength && value.length > maxLength) {
              value = value.slice(0, maxLength);
            }

            e.target.value = value;
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default InputWrapper;
